import { CommonModule } from '@angular/common';
import { Component, signal, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { MatCardModule } from '@angular/material/card';
import { NewRepApplicationPage } from '../new-rep-application/new-rep-application/new-rep-application.page';
import { BdmAssessmentComponent } from '../bdm-assessment/bdm-assessment.component';
import { NewRepChecklistComponent } from '../new-rep-checklist/new-rep-checklist.component';
import { MatIconModule } from '@angular/material/icon';
import { RmAssessmentComponent } from '../rm-assessment/rm-assessment.component';
import { DueDiliegenceComponent } from '../onboarding-assessment/due-diliegence/due-diliegence.component';
import { DsuAssessmentComponent } from '../dsu-assessment/dsu-assessment.component';
import { IntroducerFormIndividualComponent } from '../new-introducer/introducer-form-individual/introducer-form-individual.component';
import { IntroducerFormCorporateComponent } from '../new-introducer/introducer-form-corporate/introducer-form-corporate.component';
import { NewIntroducerChecklist } from '../new-introducer-checklist/new-introducer-checklist';
import { IntroducerRepAssessmentComponent } from '../introducer-rep-assessment/introducer-rep-assessment.component';

@Component({
  selector: 'app-dsu-assessment-navigation',
  imports: [
    CommonModule,
    MatTabsModule,
    PiasLayoutComponent,
    MatCardModule,
    MatTabGroup,
    NewRepApplicationPage,
    BdmAssessmentComponent,
    NewRepChecklistComponent,
    RmAssessmentComponent,
    MatIconModule,
    DueDiliegenceComponent,
    DsuAssessmentComponent,
    IntroducerFormIndividualComponent,
    IntroducerFormCorporateComponent,
    IntroducerRepAssessmentComponent,
    NewIntroducerChecklist,
  ],
  templateUrl: './dsu-assessment-navigation.page.html',
  styleUrl: './dsu-assessment-navigation.page.scss'
})
export class DsuAssessmentNavigationPage {

  @ViewChild('DsuTabs') tabGroup!: MatTabGroup;
  protected selectedTabId: string = "";
  selectedIndex: number = 0;

  // 2. Define the total number of tabs (update this based on your app)
  totalTabs: number = 6;
  data = history.state;
  status!: string;
  readonly = signal(false);
  designation!: string;

  constructor() { }
  ngOnInit(): void {
    this.selectedTabId = "new-repapplication";
    this.status = this.data.status;
    this.designation = this.data.designation;
    if (this.data.iseditable) {
      this.readonly.set(false);
    } else {
      this.readonly.set(this.data.isReadOnly);
    }
  }

  protected __onAgentOnboardingTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index; // ✅ IMPORTANT FIX

    if (event.tab.id) {
      this.selectedTabId = event.tab.id.toString();
    }
    else {
      console.error(`Invalid tab ID for mat-tab[${event.index}]`);
    }
  }


  protected nextTab(): void {
    if (this.selectedIndex < this.totalTabs - 1) {
      this.selectedIndex++; // ✅ This automatically switches tab
    }
  }

}
